export class AC101HCCalculator extends HTMLElement {
  incomeValue = 0;
  financialAssetsValue = 0;
  incomeFreeArea = 0;
  incomeThreshold = 0;
  incomeAssetThreshold = 0;
  incomeTestedFeeGreaterThanCap = false;
  incomeTestedFeeAnnualCap = 0;

  get basicDailyFee() {
    return parseFloat(this.getAttribute('basic-daily-fee')); 
  }

  get iFASingle() {
    return parseFloat(this.getAttribute('ifa-single')); 
  }
  get iFACoupleSep() {
    return parseFloat(this.getAttribute('ifa-couple-sep')); 
  }
  get iFACoupleTogether() {
    return parseFloat(this.getAttribute('ifa-couple-together')); 
  }

  get iTSingle() {
    return parseFloat(this.getAttribute('it-single')); 
  }
  get iTCoupleSep() {
    return parseFloat(this.getAttribute('it-couple-sep')); 
  }
  get iTCoupleTogether() {
    return parseFloat(this.getAttribute('it-couple-together')); 
  }

  get iATSingle() {
    return parseFloat(this.getAttribute('iat-single')); 
  }
  get iATCoupleCombined() {
    return parseFloat(this.getAttribute('iat-couple-combined')); 
  }
  
  get iFFirstCap() {
    return parseFloat(this.getAttribute('if-first-cap')); 
  }
  get iFFirstCapAnnual() {
    return parseFloat(this.getAttribute('if-first-cap-annual')); 
  }
  get iFSecondCap() {
    return parseFloat(this.getAttribute('if-second-cap')); 
  }
  get iFSecondCapAnnual() {
    return parseFloat(this.getAttribute('if-second-cap-annual')); 
  }

  get hasPartnerHomeCare() {
    return this.querySelector('input[name="has_partner"]:checked');
  }

  get livesWithPartnerHomeCare() {
    return this.querySelector('input[name="lives_with_partner"]:checked');
  }

  get incomeFreeAreaValue() {
    const has_partner = this.hasPartnerHomeCare.getAttribute("value");
    const lives_with_partner =
      this.livesWithPartnerHomeCare.getAttribute("value");

    if (has_partner == "yes") {
      if (lives_with_partner == "yes") {
        return (this.incomeFreeArea = this.iFACoupleTogether);
      } else {
        return (this.incomeFreeArea = this.iFACoupleSep);
      }
    } else {
      return (this.incomeFreeArea = this.iFASingle);
    }
  }

  get incomeThresholdValue() {
    const has_partner = this.hasPartnerHomeCare.getAttribute("value");
    const lives_with_partner =
      this.livesWithPartnerHomeCare.getAttribute("value");

    if (has_partner == "yes") {
      if (lives_with_partner == "yes") {
        return (this.incomeThreshold = this.iTCoupleTogether);
      } else {
        return (this.incomeThreshold = this.iTCoupleSep);
      }
    } else {
      return (this.incomeThreshold = this.iTSingle);
    }
  }

  get incomeAssetThresholdValue() {
    const has_partner = this.hasPartnerHomeCare.getAttribute("value");
    if (has_partner == "yes") {
      return (this.incomeAssetThreshold = this.iATCoupleCombined);
    } else {
      return (this.incomeAssetThreshold = this.iATSingle);
    }
  }

  get incomeWithRateAmount() {
    if (this.financialAssetsValue > this.incomeAssetThresholdValue) {
      const high_rate_amount =
        (this.financialAssetsValue - this.incomeAssetThresholdValue) *
        (2.25 / 100);

      return this.incomeValue + high_rate_amount;
    } else if (this.financialAssetsValue > 0) {
      const lower_rate_amount =
        Math.min(this.incomeAssetThresholdValue, this.financialAssetsValue) *
        (0.25 / 100);

      return this.incomeValue + lower_rate_amount;
    } else {
      return this.incomeValue;
    }
  }

  get totalIncome() {
    const has_partner = this.hasPartnerHomeCare.getAttribute("value");
    if (has_partner == "yes") {
      return this.incomeWithRateAmount / 2;
    } else {
      return this.incomeWithRateAmount;
    }
  }

  get incomeTestedFeeGreaterThanCapValue() {
    if (
      this.totalIncome >= this.incomeFreeAreaValue &&
      this.totalIncome < this.incomeThresholdValue
    ) {
      return (this.incomeTestedFeeGreaterThanCap = true);
    } else if (this.totalIncome >= this.incomeThresholdValue) {
      return (this.incomeTestedFeeGreaterThanCap = true);
    }
  }

  get incomeTestedFeeAnnualCapValue() {
    if (
      this.totalIncome >= this.incomeFreeAreaValue &&
      this.totalIncome < this.incomeThresholdValue
    ) {
      return (this.incomeTestedFeeAnnualCap = this.iFFirstCapAnnual);
    } else if (this.totalIncome >= this.incomeThresholdValue) {
      return (this.incomeTestedFeeAnnualCap = this.iFSecondCapAnnual);
    }
  }

  get incomeTestDailyFee() {
    if (
      this.totalIncome >= this.incomeFreeAreaValue &&
      this.totalIncome < this.incomeThresholdValue
    ) {
      const income_fee_by_cap =
        (this.totalIncome - this.incomeFreeAreaValue) / (2 * 364);
      return Math.min(income_fee_by_cap, this.iFFirstCap);
    } else if (this.totalIncome >= this.incomeThresholdValue) {
      const income_fee_by_cap =
        (this.totalIncome - this.incomeThresholdValue) / (2 * 364);
      const income_fee_by_cap_sec = income_fee_by_cap + this.iFFirstCap;
      return Math.min(income_fee_by_cap_sec, this.iFSecondCap);
    }
  }

  get totalValue() {
    const income_test_daily_fee = isNaN(this.incomeTestDailyFee)
      ? 0
      : this.incomeTestDailyFee;

    return this.basicDailyFee + income_test_daily_fee;
  }

  connectedCallback() {
    const incomeInput = this.querySelector(".income");
    const financialInput = this.querySelector(".data-financial");

    this.querySelector(".submit").addEventListener("click", (e) => {
      const income = incomeInput as HTMLInputElement;
      const financial_assets = financialInput as HTMLInputElement;

      this.incomeValue = parseFloat(income.value);
      this.financialAssetsValue = parseFloat(financial_assets.value);

      this.update();
    });

    console.log(this.iFFirstCap)
    console.log(this.iFFirstCapAnnual)
    console.log(this.iFSecondCap)
    console.log(this.iFSecondCapAnnual)
  }

  update() {
    const total_income = isNaN(this.totalIncome) ? 0 : this.totalIncome;

    const income_test_daily_fee = isNaN(this.incomeTestDailyFee)
      ? 0
      : this.incomeTestDailyFee;

    this.querySelector(
      ".hc-basic-daily-fee"
    ).textContent = `$${this.basicDailyFee.toFixed(2)}`;

    this.querySelector(
      ".hc-income-tested-daily-fee"
    ).textContent = `$${income_test_daily_fee.toFixed(2)}`;

    this.querySelector(
      ".hc-total-daily-fee"
    ).textContent = `$${this.totalValue.toFixed(2)}`;

    console.log("Total Income ", `$${total_income.toFixed(2)}`);
    console.log("");
    console.log("Basic Daily Fee ", `$${this.basicDailyFee.toFixed(2)}`);
    console.log(
      "Income tested daily fee ",
      `$${income_test_daily_fee.toFixed(2)}`
    );
    console.log("Total Daily Fee ", `$${this.totalValue.toFixed(2)}`);
    console.log("");

    console.log(this.incomeWithRateAmount);
  }
}

customElements.define("ac101-hccalculator", AC101HCCalculator);
